<template>
  <auth-template>
    <b-col md="8">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
              <h2>Confirmação da Inscrição</h2>
              <p>Prezado (a), recebemos a solicitação da sua inscrição. Até o dia 14 de novembro, você receberá um e-mail para acessar o portal de credenciamento.</p>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>

<script>
import AuthTemplate from '@/templates/auth/AuthTemplate'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  name: 'SucessoCadastroPalestrante',
  components: {
    AuthTemplate
  },
  data () {
    return {
    }
  },
  methods: {
    voltarPortal () {
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/auth/SucessoInscricao.vue